import React, { createContext, useState, useContext, useEffect } from "react";

const SchuhversorgungContext = createContext();

export const useSchuhversorgung = () => {
  const context = useContext(SchuhversorgungContext);
  if (!context) {
    throw new Error("useSchuhversorgung must be used within SchuhversorgungProvider");
  }
  return context;
};

export const SchuhversorgungProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("schuhversorgung");
    if (saved) {
      return JSON.parse(saved);
    }
    return {
      left: {},
      right: {},
    };
  });

  useEffect(() => {
    localStorage.setItem("schuhversorgung", JSON.stringify(data));
  }, [data]);

const toggle = (side, key) => {
  setData((prev) => {
    const prevSide = prev?.[side] || {};

    const newSide = { ...prevSide };

    if (prevSide[key] === "ja") {
      delete newSide[key];
    } else {
      Object.keys(newSide).forEach((k) => {
        if (k !== key) {
          delete newSide[k];
        }
      });
      newSide[key] = "ja";
    }

    return {
      ...prev,
      [side]: newSide,
    };
  });
};

  const clearSchuhversorgung = () => {
    setData({ left: {}, right: {} });
    localStorage.removeItem("schuhversorgung");
  };

  return (
    <SchuhversorgungContext.Provider value={{ data, setData, toggle, clearSchuhversorgung }}>
      {children}
    </SchuhversorgungContext.Provider>
  );
};